define.alias("shared/components/shared/carousel/inner", "settings/components/shared/carousel/inner");